<template>
	<div v-if="userAuth.isAuthShow">
	    <!-- 分配权限弹窗 -->
	    <div class="mask auth user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">分配权限 <i class="e-modal-close" @click="userAuth.isAuthShow=false"></i></div>
	            <div class="e-modal-body">
	                <table class="auth-table stripe" cellspacing="0">
	                    <tr>
	                        <td width="36px"><input type="checkbox" v-model="checkAll"></td>
	                        <td>权限名称1</td>
	                    </tr>
	                    <tr v-for="item in list" v-if="item.isShow">
	                        <td><input type="checkbox" :value="item.value" v-model="item.checked" /></td>
	                        <td>{{item.name}}</td>
	                    </tr>
	                  
	                </table>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="save">保存</div>
	                <div class="long-btn cancel-btn" @click="userAuth.isAuthShow=false">取消</div>
	            </div>
	        </div>
	    </div>
	</div>

</template>
<script>
	export default{
		name:'AllotUserAuth',
		props:{
			userAuth:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				list:[],
				checkAll:false
			}
		},
		watch:{
			userAuth(val){
				this.initTableData();
			},
			checkAll(val){
				if(val){
					this.list.forEach(function(i){
						i.checked='checked'

					})
				}else{
					this.list.forEach(function(i){
						i.checked=''

					})
				}

			}
		},
		methods:{
			initTableData(){
				var permissions=this.userAuth.Permissionons.join('');
				var AvailablePermissions=this.userAuth.AvailablePermissions.join('');
				var lists=this.getList();
				for(var i=0;i<5;i++){
					if(permissions.indexOf(lists[i].value)>-1){
						lists[i].checked='checked';
					}else{
						lists[i].checked='';
					}
					if(AvailablePermissions.indexOf(lists[i].value)>-1){
						lists[i].isShow=true;
					}else{
						lists[i].isShow=false;
					}
				}
				this.list=lists;
			},
			getList(){
				var authlist=[
					{
						name:'房态维护',
						value:1,
						checked:'',
						isShow:false
					},
					{
						name:'房价维护',
						value:2,
						checked:'',
						isShow:false
					},
					{
						name:'订单处理',
						value:3,
						checked:'',
						isShow:false
					},
					{
						name:'查看房价房态',
						value:5,
						checked:'',
						isShow:false
					},
					{
						name:'查看付款水单',
						value:7,
						checked:'',
						isShow:false
					}
				]
				return authlist;
			},
			save(){

				var that=this;
				var permission=[];
				this.list.forEach(function(i){
					if(i.checked){
						permission.push(i.value)
					}
					
				})
				var params={
					NO:this.userAuth.NO,
					IsActive:null,
					Pwd:'',
					Permissions:permission,
					Hotels:null
				}
				
			
	            that.patchRequest({
	                url: that.Api.eidtSubUser,
	                params:params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                    that.error({ title: '提示', content: '更新成功' });
	                	that.userAuth.isAuthShow=false;
	                	that.$emit('done')
	                } else {
	                    that.error({ title: '提示', content: '更新出错，请重试' });
	                }
	            });
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/user/AllotUserAuth.vue